import "./FindHome.module.css";
import Header from "@/reusable_sections/Header";
import AdvancedPropertyFilters from "./sections/AdvancedPropertyFilters";
import AvailableInventory from "./sections/AvailableInventory";
import DonTMissOut from "./sections/DonTMissOut";
import Footer from "@/reusable_sections/Footer";
export default function FindHomePage() {
  return <div>
      <Header />
      <AvailableInventory />
      <DonTMissOut />
      <AdvancedPropertyFilters />
      <Footer />
    </div>;
}